module.exports = __webpack_public_path__ + "static/img/banner_link.d7fb518.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_link.jpg
// module id = q4uK
// module chunks = 15